import { $Q, $Qll } from "../utils/query-selector";
import { modifyPrice } from "./quantity-change";

/**
 * Set form in subscription mode
 * @param {Object} - Event object
 */
 export const updatePrice = ({ dataset }, modal) => {
  let pricesContainer;

  if (!dataset) {
    /* on first load, set the subscription input data */
    const subscriptionInput = $Q('#subscription-radio');
    if (!subscriptionInput) return;
    // eslint-disable-next-line no-param-reassign
    dataset = subscriptionInput.dataset;
  }

  if (modal) {
    pricesContainer = $Qll('.price-product-js', $Q('#product-modal-js'));
  } else {
    pricesContainer = $Qll('.price-product-js', $Q('.main-product-js'));

    pricesContainer.forEach((element) => {
      const priceRegular = $Q('.regular', element)

      if (!priceRegular) return;
      priceRegular.innerHTML = dataset.price;

      const priceCompare = $Q('.compare', element);

      if (!priceCompare) return;
      priceCompare.innerHTML = dataset.compare;
    });
  }

}

/**
 * Set radio inputs events
 * @param {NodeList} radioInputs - radio inputs elements of subscription widget
 * @param {Node} form - form of product add to cart
 */
 const setEventsRadioInputs = (radioInputs, form, modal) => {
  radioInputs.forEach((radio) => {
    radio.addEventListener(
      'change',
      ({ target }) => {
        if (target.value === 'otp') {
          $Q('.frequencies-js', form).dataset.active = false;
        } else {
          $Q('.frequencies-js', form).dataset.active = true;
        }

        updatePrice(target, modal);
        if (!modal) {
          modifyPrice($Q('.main-product-js'), $Q('.main-product-js .js-input-quantity').value);
        }
      },
    );
  });
}

/**
 * Load elements and add events by product forms
 * @returns void
 */
export function loadSubscriptionForms(modal, target) {
  if (modal) {
    const form = $Q('form[action="/cart/add"]', target);
    setEventsRadioInputs($Qll('.selling-radio-js', form), form, modal);
  } else {
    $Qll('.subscription-form').forEach(
      (form) => {
        setEventsRadioInputs($Qll('.selling-radio-js', form), form);
      },
    );
  }

  updatePrice({dataset: null}, modal);
}

/**
 * Update prices from API section rendering
 *
 * @param {HTMLCollection} radiosNodes - Radio buttons: OTP & Subscription
 * @param {HTMLElement} parent - Parent of radio buttons type
 */
export const updateRadioSellingPlans = (radiosNodes, parent) => {
  radiosNodes.forEach(
    ({ id, dataset: { price, compare } }) => {
      const radio = $Q(`#${id}`, parent);
      const compareInput = $Q('.compare', radio.nextElementSibling);

      $Q('.discount', radio.nextElementSibling).textContent = price;
      compareInput && ($Q('.compare', radio.nextElementSibling).textContent = compare);

      radio.dataset.price = price;
      radio.dataset.compare = compare;
    },
  )
}

/**
 * Set more info event section of recharge widget
 * @returns void
 */
export function toggleSubscriptionInfo() {
  const subscriptionInfo = $Q('.subscription-form__info');
  const subscriptionAbout = $Q('.subscription-form__about');

  if (!subscriptionInfo || !subscriptionAbout) return;

  subscriptionInfo.addEventListener('click', () => {
    subscriptionAbout.classList.toggle('hidden')
  });
}
